import { BaseResponse } from './base.response';

export class AddShipToResponse extends BaseResponse {

  public ship: string;

}
